export default __webpack_public_path__ + "ab5c48902ebb37a4729c723a85fad0cc.svg";